import { moduleColors } from "@/styles/modules-colors";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis } from "recharts";

export function ProgressBar({
  progress,
  remaining,
  total,
  isCompleted,
}: {
  progress: number;
  remaining: number;
  total: number;
  isCompleted: boolean;
}) {
  const data = [{ done: progress, remaining }];

  return (
    <div tw="w-full h-2">
      <ResponsiveContainer width="100%" height={16}>
        <BarChart data={data} layout="vertical" barSize={16}>
          <XAxis type="number" domain={[0, total]} hide />
          <YAxis type="category" hide />

          {/* Completed */}
          <Bar
            dataKey="done"
            stackId="progress"
            fill={isCompleted ? moduleColors.greenBase : moduleColors.amberBase}
            radius={[8, 8, 8, 8]}
          />

          {/* Remaining */}
          <Bar
            dataKey="remaining"
            stackId="progress"
            fill="rgba(119, 119, 127, 0.15)"
            radius={[0, 8, 8, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
